"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routingProfileProps = undefined;

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getRoutePings = getRoutePings;
exports.getMercPoints = getMercPoints;
exports.removeEmptyProp = removeEmptyProp;
exports.buildDefaultRoutingProfile = buildDefaultRoutingProfile;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRoutePings(latLonArray) {
  return _lodash2.default.map(latLonArray, function (latLon) {
    return {
      Lon: latLon[0],
      Lat: latLon[1]
    };
  });
} /* global ALKMaps */
function getMercPoints(results, mapUtilities) {
  var points = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(results.geometry.coordinates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var coords = _step.value;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(coords), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var innerCoords = _step2.value;

          var merc = mapUtilities.LLtoMerc(innerCoords[0], innerCoords[1]);
          var point = new ALKMaps.Geometry.Point(merc.lon, merc.lat);
          points.push(point);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return points;
}
// deep clean null or undefined keys
function removeEmptyProp(obj) {
  (0, _keys2.default)(obj).forEach(function (key) {
    if (obj[key] && (0, _typeof3.default)(obj[key]) === "object") removeEmptyProp(obj[key]); // recursive
    else if (obj[key] == null || obj[key] == undefined) delete obj[key]; // delete
  });
  return obj;
}

function buildDefaultRoutingProfile(latLonArray, offRouteMiles, region) {
  return {
    RoutePings: getRoutePings(latLonArray),
    OffRouteMiles: offRouteMiles,
    HighwayOnly: false,
    Region: region,
    RoutingOptions: {
      VehicleType: 2,
      RoutingType: 1,
      HighwayOnly: false,
      UseAvoidsAndFavors: false,
      ClassOverrides: 0,
      DistanceUnits: 0,
      TollDiscourage: false,
      BordersOpen: true,
      OverrideRestrict: false, // default is false, see: SWFV-399
      HazMatType: 0,
      RouteOptimization: 0,
      HubRouting: false,
      FerryDiscourage: false,
      sideOfStreetAdherence: 0
    }
  };
}

//These objects map the fleetportal routing profile WS response object string to the ALKMaps derived route input
//See RoutingProfile.cs for the keys
var routingProfileProps = exports.routingProfileProps = {
  vehicleTypes: {
    Truck: 0,
    MidsizeTruck: 1,
    LightDuty: 1,
    Auto: 2
  },
  truckStyles: {
    Truck: 4,
    MidsizeTruck: 3,
    LightDuty: 2,
    Auto: 1
  },
  routingTypes: {
    Practical: 0,
    Shortest: 1,
    Fastest: 2,
    "0": 0, // Practical/Quickest
    "1": 1, // Shortest
    "3": 2 // Fastest(Enable Active Routes + Practical/Quickest)
  },
  classOverrides: {
    None: 0,
    NationalNetwork: 1,
    FiftyThreeFoot: 2
  },
  distanceUnits: {
    Miles: 0,
    Kilometers: 1
  },
  hazmatTypes: {
    None: 0,
    General: 1,
    Caustic: 2,
    Explosives: 3,
    Flammable: 4,
    Inhalants: 5,
    Radioactive: 6
  },
  unitTypes: {
    English: 0,
    Metric: 1
  }
};


// WEBPACK FOOTER //
// ./app/compliance/compliance.helpers.js